module["exports"] = [
  "utf8_unicode_ci",
  "utf8_general_ci",
  "utf8_bin",
  "ascii_bin",
  "ascii_general_ci",
  "cp1250_bin",
  "cp1250_general_ci"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/database/collation.js
// module id = 375
// module chunks = 0